package one.healthium.update_food_preferences.data

import co.touchlab.kermit.Logger
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.functions.functions
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.emitAll
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.flow
import kotlinx.coroutines.flow.update
import one.healthium.update_food_preferences.data.dto.FoodPreferencesDto
import one.healthium.update_food_preferences.data.mapper.FoodPreferencesMapper
import one.healthium.update_food_preferences.domain.FoodPreferencesRepository
import one.healthium.update_food_preferences.domain.models.FoodPreferenceCategoryOptions
import one.healthium.update_food_preferences.domain.models.FoodPreferencesCategoryModel

internal class AppFoodPreferencesRepository(
    private val foodPreferencesMapper: FoodPreferencesMapper
) : FoodPreferencesRepository {

    private var cache = MutableStateFlow<List<FoodPreferencesCategoryModel>?>(null)
    private val functions = Firebase.functions

    override fun getUserFoodPreferences(): Flow<List<FoodPreferencesCategoryModel>> {
        return flow {
            val cachedValue = cache.value
            cachedValue?.let { emit(it) }

            val response = functions.httpsCallable("get_user_food_preferences")
                .invoke()
                .data(FoodPreferencesDto.serializer())
            Logger.d("FoodPreferencesDto: $response")
            val models = foodPreferencesMapper.dtoToModel(response)
            cache.update { models }

            emitAll(cache.filterNotNull())
        }
    }

    override suspend fun updateUserFoodPreferences(options: List<FoodPreferenceCategoryOptions>) {
        val response = functions.httpsCallable("set_user_food_preferences")
            .invoke(foodPreferencesMapper.optionToDto(options))
            .data(FoodPreferencesDto.serializer())
        val models = foodPreferencesMapper.dtoToModel(response)
        cache.update { models }
    }
}